import { createStoreConfig } from "./common";
import { Workbook, Dashboard } from "../analytics/dasboards";

const endpoints = {
    getItems: { method: "get", url: "/client_workbooks/me" },
};

export const useOwnWorkbooksStore = createStoreConfig<Workbook>(endpoints, "ownWorkbook", {
    order_by: "name",
    in: "id__in",
    pk: "id",
    ilike: "name__ilike",
    defaultParams: { include_demo: true },
    sortOptions: { primarySortField: "name" }
})

